import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import axios from "axios";
import "./contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    mail: "",
    message: "",
    pays: "Tunisie", // default
    phoneNumber: "",
    type: 5, // fixed value
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://www.kounouz.travel/api/Home/AddContact",
        formData
      );

      if (response.status === 200) {
        setStatus("✅ Message sent successfully!");
        setFormData({
          name: "",
          mail: "",
          message: "",
          pays: "Tunisie",
          phoneNumber: "",
          type: 5,
        });
      } else {
        setStatus("⚠️ Failed to send message.");
      }
    } catch (error) {
      console.error(error);
      setStatus("❌ An error occurred. Please try again later.");
    }
  };

  const cart = [
    {
      icon: faLocationDot,
      title: "Immeuble Espace Sousse, Rue Khortoum,  Cité Turki - 4000 Sousse",
    },
    { icon: faEnvelope, title: "sales@explooration.com" },
    { icon: faPhone, title: "(+216) 58 313 890" },
  ];

  return (
    <div className="contactContainer">
      <div className="contactTitle">
        <span className="titleHeading"></span>
        <h2 className="title">Contact Us!</h2>
        <span className="titleHeading"></span>
      </div>

      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="mail"
            placeholder="Your Email"
            value={formData.mail}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phoneNumber"
            placeholder="Your Phone"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit">Send Message</button>
        </form>

        {status && <p className="statusMessage">{status}</p>}

        <button
          type="button"
          onClick={() => window.open("https://www.kounouz.travel/", "_blank")}
        >
          Find Us Here
        </button>
      </div>

      <div className="contact-info">
        {cart.map((item, id) => (
          <div key={id}>
            <div className="iconInfo" style={{ cursor: "pointer" }}>
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <h3>{item.title}</h3>
          </div>
        ))}
      </div>

      <div className="location_wrapper">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d523.389863801756!2d10.626239228742705!3d35.83691748278938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2stn!4v1757328557765!5m2!1sen!2stn"
          width="100%"
          height="500px"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="map"
        ></iframe>
      </div>
    </div>
  );
}

export default Contact;
